import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { LoaderService } from 'src/app/utils/loader.service';

interface DialogData {

}

@Component({
  selector: 'app-upload-and-download',
  templateUrl: './upload-and-download.component.html',
  styleUrls: ['./upload-and-download.component.scss']
})
export class UploadAndDownloadComponent implements OnInit {

  title: string = '';
  items: any;
  file_report_uploaded: boolean;
  inspection_file_name = ""; 
  qualityReports = [];

  // invoice_file
  private filesControl = new FormControl(null, FileUploadValidators.filesLimit(15));
  public uploadFileForm = new FormGroup({
    files: this.filesControl
  });
  quoteId: any;
  id: any;
  enquiryId: any

  constructor(
    public dialogref: MatDialogRef<UploadAndDownloadComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private adminService: AdminService,
    private toastr: ToastrService,
    public route: ActivatedRoute,
    public loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.id = this.data['id']
    this.enquiryId = this.data['enquiryId']
    this.title = this.data['model'];
    this.getallCostingTemplate()
    this.uploadFileFormFiles()
  }

  getallCostingTemplate(){
    this.adminService.getCostingTemplateDownload().subscribe(
      (res: any) => {
        this.items = res?.body?.data?.files;
      },
      err => {
        this.toastr.error('Something went wrong', 'Error');
      }
    )
  }

  close() {
    this.dialogref.close();
  }

  downloadFile(data){
    window.open(data?.url);
  }

  uploadFile() {
    let formData = new FormData();
    if(this.qualityReports.length > 0){
      this.loaderService.display(true);
      for (var i = 0; i< this.qualityReports.length; i++) {
        formData.append('costing_files', this.qualityReports[0])
      }
        formData.append('enquiryId', this.enquiryId)
      this.adminService.uploadFiles(this.id, formData).subscribe(
        (res: any) => {
          if(res?.status == 200){
            this.toastr.success('File Uploaded Successfully', 'success');
            this.loaderService.display(false);
            this.close();
          } else {
            this.toastr.error('Please check your files', 'Error!')
            this.loaderService.display(false);
          }
        },
        err => {
          this.toastr.error('Something went wrong', 'Error');
          this.loaderService.display(false);
        }
      )
    } else {
      this.toastr.error('Please Upload files', 'Error!')
    }
  }

  public supporteduploadFileFormFiletypes: Array<string> = [ 'pdf', 'xls', 'xlsx' ];
  uploadFileFormFiles() {
    const uploadFile = this.uploadFileForm.get('files')
    uploadFile.valueChanges.subscribe(
      (res: any) => {
        if (res == null || res.length == 0) {
          this.file_report_uploaded = false;
        }
        else {
          for (var i = 0; i < res.length; i++) {
            this.qualityReports.push(res[i]);
            let allSplits = (res[i].name).split('.');
            let type = allSplits[allSplits.length - 1];
            if (!this.supporteduploadFileFormFiletypes.includes(type)) {
              this.toastr.error('Upload file type not supported', 'Error');
              setTimeout(()=>{
                this.uploadFileForm.get('files').setValue([]);
              }, 500);
              this.qualityReports = [];
            }
            this.file_report_uploaded = true;
          }
        }
      },
      err => {
        this.toastr.error('Error Uploading File', 'Error');
      }
    )
  }

  deleteQualityReport(index) {
    this.qualityReports.splice(index, 1)
    if(typeof this.qualityReports !== 'undefined' && this.qualityReports?.length > 0) {
    } else {
      this.file_report_uploaded = false;
      this.qualityReports = [];
      this.uploadFileForm.reset();
      this.uploadFileForm.reset(this.uploadFileForm.value);
      this.uploadFileForm.clearValidators();
    }
  }
}